import { ShiftsSwapShiftFragment } from 'generated/resources/graphql'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import SwapShift from 'modules/shift_management/store/internal//models/SwapShift'

class SwapShifts extends Collection<SwapShift> {
  constructor(swapShift: SwapShift[]) {
    super(swapShift)

    makeObservable(this, {
      pending: computed,
      approved: computed,
    })
  }

  model() {
    return SwapShift
  }

  get cacheKey(): string {
    return 'swapShifts'
  }

  static buildFromRequest(swapShifts: ShiftsSwapShiftFragment[]): SwapShifts {
    const swapShiftsObjects = swapShifts.map((swapShift) => SwapShift.buildFromRequest(swapShift))

    return new SwapShifts(swapShiftsObjects)
  }

  get pending(): SwapShift[] {
    return this.models.filter(({ status }) => status === SwapShift.types.pending)
  }

  get approved(): SwapShift[] {
    return this.models.filter(({ status }) => status === SwapShift.types.approved)
  }
}

export default SwapShifts
